export default __webpack_public_path__ + "static/media/petri-dish-lb-amp.dc7bc7e5.svg";